import { Component, input, signal } from '@angular/core';
import { PictureModel } from '@big-direkt/utils/shared';

@Component({
    selector: 'big-ui-picture',
    templateUrl: './picture.component.html',
    standalone: false,
})
export class PictureComponent {
    public readonly model = input<PictureModel>();
    public readonly pictureClass = input<string>('');
    public readonly hasBrokenImage = signal(false);
    public readonly contain = input<boolean>(false);

    public onError(): void {
        this.hasBrokenImage.set(true);
    }
}
